import { gql, useQuery } from "@apollo/client";

export const RentingByCostumer = gql`
	query RentingByCostumer($id: String) {
		rentingsByUser(id: $id) {
			_id
			pricePerDay
			client
			machine
			status
			startedRent
			endedRent
			previsionEndingRent
			machineInfo {
				_id
				name
			}
		}
	}
`;
